import { layouts, themes } from "../pages/WebTemplate/templates/index";

export const businessTypeEnum = {
    EVENT: "event",
    HOTEL: "hotel",
    TICKETING: "ticketing",
    TRAVEL: "travel",
};
export const companyTypeEnum = {
    PRIVATE: "private",
    PROPRIETORSHIP: "proprietorship",
    PUBLIC: "public",
};
export const travelModeEnum = {
    AIR: "air",
    BUS: "bus",
    SHIP: "ship",
    LAUNCH: "launch",
};
export const acTypeEnum = {
    AC: "ac",
    NON_AC: "non_ac",
};
export const amountTypeEnum = {
    FIXED_AMOUNT: "fixed_amount",
    PERCENTAGE: "percentage",
};
export const categoryTypeEnum = {
    ONLINE: "online",
    COUNTER: "counter",
};
export const channelTypeEnum = {
    WEB_APP: "web_app",
    MOBILE_APP: "mobile_app",
    AGENT_APP: "agent_app",
};
export const commissionModeEnum = {
    SAAS: "saas",
    COUNTER: "counter",
    AGENT: "agent",
    API: "api",
};
export const quotaModeEnum = {
    ONLINE: "online",
    COUNTER: "counter",
    VIP: "vip",
};

export const PaymentGatewayEnum = {
    BKASH: "bkash",
    CASH: "cash",
    CELLFIN: "cellfin",
    NAGAD: "nagad",
    PORTPOS: "portpos",
    ROBICASH: "robicash",
    UPAY: "upay",
    SSLCOMMERZ: "sslcommerz"
};

export const GatewayCategoryEnum = {
    ADJUSTMENT: "adjustment",
    CARDS: "cards",
    DISBURSEMENT: "disbursement",
    INTERNET_BANKING: "internet_banking",
    MFS: "mfs",
    PSO: "pso",
};

export const CALL_CENTRE_NUMBER = "+8809610016460";

export const COMPANY_CONFIG_KEYS = {
    company_type: "company_type",
    address: "address",
    call_centre_number: "call_centre_number",
    mobile_number: "mobile_number",
    email: "email",
    primary_contact_person: "primary_contact_person",
    primary_contact_person_mobile_number:
        "primary_contact_person_mobile_number",
    secondary_contact: "secondary_contact",
    secondary_contact_mobile_number: "secondary_contact_mobile_number",
    base_station: "base_station",
    country: "country",
    logo: "logo",
    attendance: "attendance",
    passenger_info: "passenger_info",
    required_passenger_details: "required_passenger_details",
    ladies_seat_validation: "ladies_seat_validation",
    // one_time_ticket_print_limit: "one_time_ticket_print_limit",
    issue_printing_counter_same: "issue_printing_counter_same",
    max_ticket_print_count: "max_ticket_print_count",
    qr_code_in_ticket: "qr_code_in_ticket",
    new_user_add_notification_sms: "new_user_add_notification_sms",
    cancellation_reissue_verification_sms:
        "cancellation_reissue_verification_sms",
    web_meta_description: "web_meta_description",
    web_meta_keywords: "web_meta_keywords",
    web_title: "web_title",
    time_format: "time_format",
    day_start_time: "day_start_time",
    ticket_availability_window: "ticket_availability_window",
    past_trip_history: "past_trip_history",
    counter_fund_request_time_frame_start:
        "counter_fund_request_time_frame_start",
    counter_fund_request_time_frame_end: "counter_fund_request_time_frame_end",
    online_ticket_sale: "online_ticket_sale",
    automated_report_email: "automated_report_email",
    reporting_email: "reporting_email",
    counter_booking_expiry_default_time: "counter_booking_expiry_default_time",
    seat_plan_templates: "seat_plan_templates",
    manual_ticket_print: "manual_ticket_print",
    personal_information: "personal_information",
};

export const COUNTRIES = { BANGLADESH: "bangladesh", INDIA: "india" };

export const ROLE_TYPES = {
    SUPER_ADMIN: "SUPER_ADMIN",
    GDS_ADMIN: "GDS_ADMIN",
    GDS_CALL_CENTRE_AGENT: "GDS_CALL_CENTRE_AGENT",
    COMPANY_ADMIN: "COMPANY_ADMIN",
    COMPANY_CALL_CENTRE_MANAGER: "COMPANY_CALL_CENTRE_MANAGER",
    COMPANY_COUNTER: "COMPANY_COUNTER",
    COMPANY_RETAILER: "COMPANY_RETAILER",
    AGENT_ADMIN: "AGENT_ADMIN",
    AGENT_HUNTER: "AGENT_HUNTER",
};

export const WEB_LAYOUTS = layouts;
export const WEB_THEME = themes;
export const allowedNameChars = "\\\\!@#$%^&*()\\[\\]{};:,./'\"-";
export const allowedContactNameChars = ".:-";

export const AUTH_SERVICE_DOMAIN = "cms";

export const SeatDirections = {
    horizontal: "Horizontal (A1 | A2 | A3)",
    vertical: "Vertical (1A | 1B | 1C)",
};

export const SEAT_TYPE = {
    CHAIR: "chair",
    BERTH: "berth",
};

export const GOOGLE_RECAPTCHA_KEY = process.env.MIX_GOOGLE_RECAPTCHA_KEY || "";
export const GOOGLE_RECAPTCHA_LANGUAGE =
    process.env.MIX_GOOGLE_RECAPTCHA_LANGUAGE || "bn";

export const cellSizeProperyMultiplier = 1.5;
export const defaultMinHeightWidth = 50;

export const seatColors = [
    "#57ff7b",
    "#d1968a",
    "#3e8203",
    "#ffbf57",
    "#9d57ff",
    "#ff5757",
    "#c23868",
    "#57dbff",
    "#ba188c",
    "#73ff57",
    "#f6fa05",
    "#52b392",
    "#ff5797",
    "#6b57ff",
    "#f4ff57",
    "#1153b8",
    "#03a125",
    "#db57ff",
    "#57ffb6",
    "#9e4823",
    "#57ff7b",
    "#ff8957",
    "#5795ff",
    "#8dbf57",
];
